import { isUuid } from '@couchbasecloud/base-ui/utils/uuid';
import { debugLog } from 'utils/debug';

export const validateOrganizationStorage = (persistedOrganization: unknown): persistedOrganization is string => {
  if (typeof persistedOrganization === 'string' && !!persistedOrganization) {
    const [, organizationId] = persistedOrganization.split(':');

    if (isUuid(organizationId)) {
      return true;
    }
  }
  debugLog('hooks/use-organization-manager.utils validateOrganizationStorage() valid organizationId was not stored');
  return false;
};
